var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003_10020)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.99982,
    cy: 7.99908,
    r: 1.91485,
    stroke: "#5D6165",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.39959 3.19811L3.29462 2.96204C4.05263 2.25377 4.97062 1.71457 5.98849 1.40454L6.14159 1.61505C7.05922 2.8768 8.94062 2.8768 9.85826 1.61505L10.0114 1.40454C11.0292 1.71457 11.9472 2.25377 12.7052 2.96204L12.6003 3.19812C11.9664 4.62369 12.9071 6.25303 14.4586 6.41685L14.7171 6.44415C14.8324 6.94413 14.8934 7.46492 14.8934 7.99994C14.8934 8.53497 14.8324 9.05575 14.7171 9.55574L14.4586 9.58303C12.9071 9.74685 11.9664 11.3762 12.6003 12.8018L12.7052 13.0378C11.9472 13.7461 11.0292 14.2853 10.0113 14.5954L9.85826 14.3849C8.94062 13.1231 7.05922 13.1231 6.14159 14.3849L5.98851 14.5954C4.97063 14.2853 4.05263 13.7461 3.29461 13.0378L3.39959 12.8018C4.03347 11.3762 3.09277 9.74686 1.54125 9.58304L1.28273 9.55574C1.1674 9.05576 1.10645 8.53497 1.10645 7.99994C1.10645 7.46492 1.1674 6.94413 1.28274 6.44414L1.54126 6.41684C3.09278 6.25302 4.03348 4.62368 3.39959 3.19811Z",
    stroke: "#5D6165",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003_10020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/setting_icon.65963278fa8bdabfd3a4454f354d0304.svg";
export { ForwardRef as ReactComponent };